module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch07"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page39"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_07"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("chapter 7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/39.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_vm._v("12:51 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("Gabriel opened his eyes.")]), _vm._v(" Through a chrysalis of jagged metal, he saw a woman in the distance, covering her face and repeating, “Shit, shit! My skin’s burning, my skin’s burning! Come quick, Roger, it burns!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He wanted to see what was wrong. He turned.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Searing pain.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Blackness.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fourteen minutes later, Joaquin awoke on a stretcher with an oxygen mask strapped over his face. He could only see rough shapes, and he heard voices, distant, garbled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Front seat…killed instantly…meat wagon…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another voice mixed with his, complaining:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Can you imagine? What would you do if your boss said something like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The first voice again, clearer:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You did the right thing, but you got to think about how this is gonna affect your retirement. Pass me the scissors—thanks. There’s nothing more we can do here. How long before the meat wagon arrives?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He couldn’t understand what they were talking about. It was as if they were referring to strangers. For a moment he thought he was hearing a medical show. He continued to listen.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“If we can’t stop the hemorrhaging, this one’s gonna code on us,” said another voice farther away.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I don’t like these shows, Gabriel thought. I’m going to change the channel.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page41"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Where’s the remote? Will someone pass the remote?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He heard laughing and a joke about couch potatoes that he didn’t understand. Then he sank back into the blackness.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Wonderful, welcoming blackness.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7d5547c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter07.vue
// module id = 93
// module chunks = 0